import { lazy } from 'react';
import { Loader } from '@client/components/common/Loader';
import { useSelector } from '@client/hooks/redux.hooks';
import { getSessionUserState } from '@client/selectors/helpers/login';
import { useIsMobile } from '@client/hooks/dom.hooks';

const BottomAppBarLoggedIn = lazy(() => import('./BottomAppBarLoggedIn'));
const BottomAppBarLoggedOut = lazy(() => import('./BottomAppBarLoggedOut'));

export const BottomAppBar = () => {
  const userState = useSelector(getSessionUserState);
  const isMobile = useIsMobile();

  if (!isMobile) {
    return null;
  }

  if (!userState) {
    return <Loader load={BottomAppBarLoggedOut} />;
  }

  return (
    <Loader load={BottomAppBarLoggedIn} />
  );
};
